var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "logo_svg__Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 287 57"
  },
  viewBox: "0 0 287 57"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__Adobe_OpacityMaskFilter",
  width: 15.7,
  height: 15.9,
  x: 237.7,
  y: 15.7,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b_00000152263307144967924630000015174916045794564236_",
  width: 15.7,
  height: 15.9,
  x: 237.7,
  y: 15.7,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#logo_svg__Adobe_OpacityMaskFilter)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a_00000139287727249681511810000010107210837211989387_",
  d: "M0 51.4h258.9V.1H0z",
  className: "logo_svg__st1"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M253.3 19.9c-6.4-2.3-7.2 1.6-7.2 3.7 0 .3-.1.4-.1 0-.1-.8-.2-1.9-1.1-3.7-1.7-3.6-5.5-2.7-6.7-4.1-.1-.1-.2-.1-.2-.1l.2.2-.2-.2s-.1.1 0 .2c1.1 1.5-.9 4.9 2.1 7.6 1.5 1.3 2.5 1.8 3.2 2.1.4.2.3.2 0 .1-2.1-.6-6.1-1-5.6 5.8 3.7-3.9 6.9-2 8.4-.4.1.1.2.1.3.1.2-.1.3-.2.3-.2.4-.3 1.7-1.3 1.7-1.3s1.6-1.2 1.8-1.4l.2-.1q.15-.15 0-.3c-.9-1.9-1.9-5.5 2.9-8q.15 0 0 0",
  style: {
    mask: "url(#logo_svg__b_00000152263307144967924630000015174916045794564236_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f3b229"
  }
}), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__Adobe_OpacityMaskFilter_00000099627447857598462650000012378668747778435511_",
  width: 38.1,
  height: 38.7,
  x: 214.7,
  y: 12.8,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b_00000178905291066387451870000016801487135344356761_",
  width: 38.1,
  height: 38.7,
  x: 214.7,
  y: 12.8,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#logo_svg__Adobe_OpacityMaskFilter_00000099627447857598462650000012378668747778435511_)"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a_00000063625048789743157300000013568030729970623896_",
  d: "M0 51.4h258.9V.1H0z",
  className: "logo_svg__st1"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m250.9 29.5-3.6 2.7s-.1.1-.1.2l.3.9c2.5 13.3-9.8 13.2-11.9 13.1-4.9-.2-8.8-2.5-11.7-4.9-8.4-7.1-9-20.9-5.7-26.8.1-.3-.1-2.3-.5-1.8-1.3 2.5-3.3 7.6-3 14.2.3 6.1 2.1 10.7 4.8 14.6 4 5.9 11.7 10.7 20.1 9.6 13.8-1.8 15-14.6 11.6-21.9 0 0-.1 0-.3.1",
  style: {
    mask: "url(#logo_svg__b_00000178905291066387451870000016801487135344356761_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0082a4"
  }
}), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__Adobe_OpacityMaskFilter_00000159451453524418913090000010616089177883535289_",
  width: 38,
  height: 38.9,
  x: 221,
  y: 0.1,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b_00000174581156275639211280000018255043735326854785_",
  width: 38,
  height: 38.9,
  x: 221,
  y: 0.1,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#logo_svg__Adobe_OpacityMaskFilter_00000159451453524418913090000010616089177883535289_)"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a_00000090276334733019439130000017544127002556484797_",
  d: "M0 51.4h258.9V.1H0z",
  className: "logo_svg__st1"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M258.9 24.7c-.2-6.1-2-10.7-4.6-14.7-4-5.9-11.6-10.8-20-9.8-13.9 1.6-15.1 14.4-11.9 21.7 0 0 .1.1.3-.1 0 0 3.2-2.3 3.6-2.6 0 0 .1-.1.1-.2l-.3-.9c-2.3-13.4 10-13.1 12.1-12.9 4.9.3 8.7 2.6 11.6 5 8.3 7.2 8.7 21 5.4 26.9-.1.3 0 2.3.5 1.8 1.4-2.5 3.4-7.5 3.2-14.2",
  style: {
    mask: "url(#logo_svg__b_00000174581156275639211280000018255043735326854785_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0082a4"
  }
}), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__Adobe_OpacityMaskFilter_00000116200860741462810440000004534346969290543241_",
  width: 15.8,
  height: 15.9,
  x: 220.2,
  y: 20,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b_00000066482137945659575560000015928784513332209299_",
  width: 15.8,
  height: 15.9,
  x: 220.2,
  y: 20,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#logo_svg__Adobe_OpacityMaskFilter_00000116200860741462810440000004534346969290543241_)"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a_00000005269116718099001420000010182844962797566372_",
  d: "M0 51.4h258.9V.1H0z",
  className: "logo_svg__st1"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M233.4 28.1c-1.5-1.3-2.4-1.8-3.2-2.1-.4-.2-.3-.2 0-.1 2.1.7 6 1.1 5.7-5.7h-.1c-3.7 3.9-6.9 1.9-8.4.3-.1-.1-.2-.1-.3-.1-.2.1-.3.2-.3.2-.4.3-1.7 1.2-1.7 1.2s-1.6 1.2-1.8 1.4l-.2.1q-.15.15 0 .3c1 1.9 1.9 5.5-2.9 7.9v.1c6.4 2.4 7.2-1.5 7.2-3.7 0-.3.1-.4.1 0 .1.9.2 1.9 1 3.7 1.6 3.6 5.5 2.8 6.6 4.2.1.1.2.1.2.1-.1-.1-.1-.2-.2-.2l.2.2s.1-.1 0-.2c-1-1.6 1-5-1.9-7.6",
  style: {
    mask: "url(#logo_svg__b_00000066482137945659575560000015928784513332209299_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f3b229"
  }
}), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__Adobe_OpacityMaskFilter_00000060714180609544456250000015289907928496232122_",
  width: 8.6,
  height: 18.5,
  x: 0,
  y: 19.9,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b_00000159445216055388961300000005050158675041091997_",
  width: 8.6,
  height: 18.5,
  x: 0,
  y: 19.9,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#logo_svg__Adobe_OpacityMaskFilter_00000060714180609544456250000015289907928496232122_)"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a_00000029760709211240114820000000825053176343125933_",
  d: "M0 51.4h258.9V.1H0z",
  className: "logo_svg__st1"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M0 19.9v18.5h8.6v-2.3H3.4V19.9z",
  style: {
    mask: "url(#logo_svg__b_00000159445216055388961300000005050158675041091997_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0082a4"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3 38.7c-3.9 0-5.6-1.7-5.6-4.9v-9.9H15V34c0 1.4.8 2.5 2.4 2.5.9 0 1.6-.2 2.2-.5V23.9h3.3v13.6c-1.2.7-3.1 1.2-5.6 1.2m12.7 0c-1.7 0-3.2-.5-4-1l.9-2.1c.5.4 1.5.8 2.7.8 1.3 0 2.2-.9 2.2-2 0-1.2-.6-1.8-2.1-2.4-2.7-1-3.3-2.6-3.3-4.1 0-2.3 1.8-4.2 4.6-4.2 1.6 0 2.8.4 3.8 1l-.8 1.9c-.7-.5-1.5-.8-2.3-.8-1.3 0-2.1.9-2.1 1.9 0 1.2.9 1.8 2.2 2.3 2.8 1.1 3.5 2.6 3.5 4.3-.1 2.3-2.1 4.4-5.3 4.4m13.3-.1c-2.9 0-4-1.9-4-3.9V26h-1.6v-2.1h1.6v-3.2l3.3-.9v4.1H45V26h-2.4v8.5c0 1.1.5 1.9 1.6 1.9.3 0 .5-.1.8-.1v2c-.3.1-.9.3-1.7.3m7.3-6.2c.3 2.7 1.6 4 4 4 1.7 0 2.9-.4 3.7-.8l.8 2.1c-1 .6-2.6 1-4.8 1-4.1 0-6.7-2.7-6.7-7.6 0-4.7 2.4-7.5 6.2-7.5 3.9 0 5.9 2.6 5.8 7.4-.2.1-9 1.4-9 1.4m2.9-6.7c-1.9 0-3.2 1.6-3.1 5l6-.9c0-2.9-1.1-4.1-2.9-4.1m15.8.4c-1.1-.4-2.3-.3-3.1.1v12.2H63V24.7c1.5-.7 3.3-1.1 7-1zm15 12.6c-2.2 0-3.6-.4-4.6-1.1l.8-2.4c.6.4 1.7.9 3.1.9 1.8 0 3-1.1 3-2.9 0-1.4-.8-2.3-2.9-3.1-3-1.3-3.8-3.3-3.8-5.1 0-2.9 2.1-5.4 5.5-5.4 1.9 0 3.2.5 4.1 1l-.8 2.1c-.6-.4-1.7-.8-2.9-.8-1.7 0-2.7 1.1-2.7 2.7s1.2 2.4 2.8 3c3.6 1.5 4.2 3.6 4.2 5.4.1 3.3-2.3 5.7-5.8 5.7m14.8-.1c-.8 0-1.7-.1-2.2-.3v5.9h-3.3V24.7c1.1-.6 2.7-1 5-1 4.2 0 6.8 2.7 6.8 7.3.1 4.8-2.5 7.6-6.3 7.6m-.5-13c-.7 0-1.2.1-1.7.3v10.5c.4.2.9.2 1.5.2 2.6 0 3.8-2 3.8-5.5 0-3.4-.9-5.5-3.6-5.5m15.5 13.1c-4 0-5.9-1.6-5.9-4.4 0-3.8 3.7-4.9 8.1-5.4v-.8c0-1.9-1.2-2.4-2.9-2.4-1.4 0-2.7.5-3.6.9l-.8-1.9c.9-.5 2.7-1.1 5-1.1 3 0 5.4 1.3 5.4 5v9c-1.2.7-3.1 1.1-5.3 1.1m2.1-8.2c-3.1.4-5 1.1-5 3.7 0 1.9 1.1 2.7 3 2.7.8 0 1.5-.2 2-.4zm13.5-4.4c-1.1-.4-2.3-.3-3.1.1v12.2h-3.3V24.7c1.5-.7 3.3-1.1 7-1zm5.9 6.3c.3 2.7 1.6 4 4 4 1.7 0 2.9-.4 3.7-.8l.8 2.1c-1 .6-2.6 1-4.8 1-4.1 0-6.7-2.7-6.7-7.6 0-4.7 2.4-7.5 6.2-7.5s5.9 2.6 5.8 7.4c-.1.1-9 1.4-9 1.4m3-6.7c-1.9 0-3.2 1.6-3.1 5l6-.9c-.1-2.9-1.1-4.1-2.9-4.1m14.2 13c-2.2 0-3.9-.5-4.8-1.1V17.3h3.3v7c.7-.3 1.5-.6 2.9-.6 3.4 0 5.7 2.8 5.7 7.1-.1 4.9-2.6 7.9-7.1 7.9m.4-13c-.9 0-1.4.1-2 .4v10.3c.4.2 1 .3 1.7.3 2.6 0 3.6-2.2 3.6-5.6.1-3.1-.8-5.4-3.3-5.4m15.4 13c-4 0-5.9-1.6-5.9-4.4 0-3.8 3.7-4.9 8.1-5.4v-.8c0-1.9-1.2-2.4-2.9-2.4-1.4 0-2.7.5-3.6.9l-.8-1.9c.9-.5 2.7-1.1 5-1.1 3 0 5.4 1.3 5.4 5v9c-1.3.7-3.1 1.1-5.3 1.1m2.1-8.2c-3.1.4-5 1.1-5 3.7 0 1.9 1.1 2.7 3 2.7.8 0 1.5-.2 2-.4zm15.3 7.9V28.2c0-1.2-.5-2.4-2.6-2.4-1.1 0-1.6.2-2.3.4v12.3h-3.3V24.7c1.4-.6 3.2-1.1 5.7-1.1 4.3 0 5.8 2.1 5.8 4.4v10.3H186m15.8.1L197 31h-.1v7.4h-3.3V17.3h3.3v13.2h.1l4.6-6.6h3.3l-5 6.6 5.6 7.9z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0082a4"
  }
}));
export default SvgLogo;